export default __webpack_public_path__ + "static/media/character-dousetsu.fa8345e0.png";